/**
 * Les chemins de premier niveau qui ne sont **pas** préfixés par une langue.
 *
 * Le site range tout sous `/:lang/...`, et trois mécanismes indépendants
 * ramènent vers cette forme : le routeur de langue, son repli, et la génération
 * des `hreflang`. Une route hors langue doit donc être connue des trois — la
 * liste vivait en dur à chacun de ces endroits, et en oublier un ne se voyait
 * qu'à l'usage : `/import/<id>` était alors renvoyé vers `/fr/import/<id>`,
 * puis rendu comme un passage biblique du livre « import ».
 */
export const nonLanguageRoutes = ['app', 'daily-readings', 'import', 'read'];

/** Vrai si `pathname` désigne une route hors langue. */
export function isNonLanguageRoute(pathname: string): boolean {
  const first = pathname.split('/').filter(Boolean)[0];
  return !!first && nonLanguageRoutes.includes(first);
}
